import type {Availability} from '@/redux/v1/availability/models';
import type {AlternativeFlightOffer as RawAlternativeFlightOffer} from '@/redux/v1/offerAlternativeFlights/models';
import type {UpsellingOffer as RawUpsellingOffer} from '@/redux/v1/offerUpselling/models';

export const OFFER_BOX_TAB_UPSELLING_OFFERS =
  'offer-box-tab-upselling-offers' as const;
export const OFFER_BOX_TAB_ALTERNATIVE_FLIGHTS =
  'offer-box-tab-alternative-flights' as const;

export type OfferBoxTab =
  | typeof OFFER_BOX_TAB_UPSELLING_OFFERS
  | typeof OFFER_BOX_TAB_ALTERNATIVE_FLIGHTS;

export const OFFER_BOX_EVENT_ORIGIN_FLIGHT_DETAILS_BUTTON =
  'offer-box-event-origin-flight-details-button' as const;
export const OFFER_BOX_EVENT_ORIGIN_OFFER_DETAILS_BUTTON =
  'offer-box-event-origin-offer-details-button' as const;
export const OFFER_BOX_EVENT_ORIGIN_CTA_BUTTON =
  'offer-box-event-origin-cta-button' as const;
export const OFFER_BOX_EVENT_ORIGIN_UPSELLING_BUTTON =
  'offer-box-event-origin-upselling-button' as const;
export const OFFER_BOX_EVENT_ORIGIN_ALTERNATIVE_FLIGHTS_BUTTON =
  'offer-box-event-origin-alternative-flights-button' as const;
export const OFFER_BOX_EVENT_ORIGIN_UPSELLING_OFFER =
  'offer-box-event-origin-upselling-offer' as const;
export const OFFER_BOX_EVENT_ORIGIN_ALTERNATIVE_FLIGHT_OFFER =
  'offer-box-event-origin-alternative-flight-offer' as const;
export const OFFER_BOX_EVENT_ORIGIN_ALTERNATIVE_OFFERS_LAYER_CLOSE_BUTTON =
  'offer-box-event-origin-alternative-offers-layer-close-button' as const;

export type OfferBoxEventOrigin =
  | typeof OFFER_BOX_EVENT_ORIGIN_FLIGHT_DETAILS_BUTTON
  | typeof OFFER_BOX_EVENT_ORIGIN_OFFER_DETAILS_BUTTON
  | typeof OFFER_BOX_EVENT_ORIGIN_CTA_BUTTON
  | typeof OFFER_BOX_EVENT_ORIGIN_UPSELLING_BUTTON
  | typeof OFFER_BOX_EVENT_ORIGIN_ALTERNATIVE_FLIGHTS_BUTTON
  | typeof OFFER_BOX_EVENT_ORIGIN_UPSELLING_OFFER
  | typeof OFFER_BOX_EVENT_ORIGIN_ALTERNATIVE_FLIGHT_OFFER
  | typeof OFFER_BOX_EVENT_ORIGIN_ALTERNATIVE_OFFERS_LAYER_CLOSE_BUTTON;

export type Upselling = {
  id: string;
  title: string;
  description: string;
  tooltipContent: string | React.ReactElement | null;
  count?: number;
};

export type UpsellingOffer = {
  offer: RawUpsellingOffer;
  availability: Availability;
};

export type AlternativeFlightOffer = {
  offer: RawAlternativeFlightOffer;
  availability: Availability;
};
